import { useTranslation } from "react-i18next";

import { AlertPanel } from "../../../../../../alert-panel/AlertPanel";
import { formatEuro } from "../../../../../../format/formatNumber";
import { BankruptcyCapabilityResponse } from "../../../../../api/ClientFileApi";
import { FormattedText } from "../../../formatted-text/FormattedText";
import { isBankruptcyCapabilityGiven } from "../../BankruptcyCapability.utils";

const TRANSLATION_BASE = "clients.client.debtSettlement.bankruptcyChecklist.bankruptcyCapability";

interface Props {
  capability: BankruptcyCapabilityResponse;
}

export function CapabilityResult({ capability }: Props) {
  const { t, i18n } = useTranslation();
  const isGiven = isBankruptcyCapabilityGiven(capability);

  return (
    <AlertPanel
      severity={isGiven ? "success" : "warning"}
      title={t(`${TRANSLATION_BASE}.result.${isGiven ? "givenTitle" : "notGivenTitle"}`)}
    >
      {isGiven ? (
        <FormattedText
          text={t(`${TRANSLATION_BASE}.result.given`, {
            income: formatEuro(capability.monthlyIncome, i18n.language),
            expenses: formatEuro(capability.monthlyExpenses, i18n.language),
            count: capability.maintenanceObligationCount ?? 0,
            amount: formatEuro(capability.seizableAmount, i18n.language),
          })}
        />
      ) : (
        <FormattedText text={t(`${TRANSLATION_BASE}.result.notGiven`)} />
      )}
    </AlertPanel>
  );
}
